import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d995dbc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "vrt-body"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "Trailer Not Found", -1))
const _hoisted_4 = { class: "vrt-subtitle" }
const _hoisted_5 = { class: "vrt-actions" }
const _hoisted_6 = {
  key: 1,
  class: "vrt-body"
}
const _hoisted_7 = { class: "vrt-title" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "vrt-subtitle" }, " We don't have a VIN or plate number on file for this trailer to confirm against. Please verify you are entering the correct trailer number or contact your driver manager if you continue to have issues. ", -1))
const _hoisted_10 = { class: "vrt-actions" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "vrt-subtitle" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "vrt-field"
}
const _hoisted_15 = {
  key: 1,
  class: "vrt-divider"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vrt-divider-line" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "vrt-divider-text" }, "or", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vrt-divider-line" }, null, -1))
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "vrt-field"
}
const _hoisted_21 = { class: "vrt-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualRedTagHeader = _resolveComponent("VirtualRedTagHeader")!
  const _component_fbx_button = _resolveComponent("fbx-button")!
  const _component_fbx_input = _resolveComponent("fbx-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VirtualRedTagHeader),
    (_ctx.notFound)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, " We couldn't find trailer #" + _toDisplayString(_ctx.trailerNumber) + ". Please verify you entered the correct trailer number. ", 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_fbx_button, {
              "button-text": "Go Back",
              theme: "primary",
              onClick: _ctx.navigateBack
            }, null, 8, ["onClick"])
          ])
        ]))
      : (_ctx.trailer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h1", _hoisted_7, " Confirm " + _toDisplayString(_ctx.trailerTypeLabel) + " #" + _toDisplayString(_ctx.trailer.trailerNumber), 1),
            (_ctx.cannotVerify)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_fbx_button, {
                      "button-text": "Go Back",
                      theme: "primary",
                      onClick: _ctx.navigateBack
                    }, null, 8, ["onClick"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, [
                    _createTextVNode(" Please verify you have the correct trailer. Enter the "),
                    _createElementVNode("span", { innerHTML: _ctx.vinOrPlateText }, null, 8, _hoisted_13),
                    _createTextVNode(" to confirm. ")
                  ]),
                  (_ctx.hasVin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_fbx_input, {
                          id: "vrt-vin",
                          label: "Last 6 digits of the VIN *",
                          model: _ctx.vin,
                          alert: _ctx.vinAlert,
                          trim: true,
                          limit: 6,
                          "onUpdate:modelValue": _ctx.onVinChanged,
                          onKeyup: _withKeys(_withModifiers(_ctx.onContinue, ["prevent"]), ["enter"])
                        }, null, 8, ["model", "alert", "onUpdate:modelValue", "onKeyup"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hasVin && _ctx.hasLicensePlateNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_19))
                    : _createCommentVNode("", true),
                  (_ctx.hasLicensePlateNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_fbx_input, {
                          id: "vrt-plate",
                          label: "Plate Number *",
                          model: _ctx.licensePlate,
                          alert: _ctx.plateAlert,
                          trim: true,
                          "onUpdate:modelValue": _ctx.onPlateChanged,
                          onKeyup: _withKeys(_withModifiers(_ctx.onContinue, ["prevent"]), ["enter"])
                        }, null, 8, ["model", "alert", "onUpdate:modelValue", "onKeyup"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_fbx_button, {
                      "button-text": "Continue",
                      theme: "primary",
                      disabled: _ctx.isInvalidInput,
                      "show-loading": _ctx.isLoading,
                      onClick: _ctx.onContinue
                    }, null, 8, ["disabled", "show-loading", "onClick"]),
                    _createVNode(_component_fbx_button, {
                      "button-text": "Go Back",
                      theme: "primaryOutline",
                      class: "italic",
                      onClick: _ctx.navigateBack
                    }, null, 8, ["onClick"])
                  ])
                ]))
          ]))
        : _createCommentVNode("", true)
  ]))
}